import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getRunningStreamTemplates = createAsyncThunk("stream/getStreamTemplates", async (payload) => {
  try {
    const response = await magnifiAPI.getRunningStreamTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
